/* Luck game (Plinko) v2, 17.9.2026. One panel: board, form, step 2 and the code in the same card, inline in the
   page (no iframe). Markup: snippets/luck-game.liquid. Styles: assets/luck-game.css.
   The host snippet owns the tab, the timing rules and open/close, and talks to this module through two events:
   'jrs:luck:open' and 'jrs:luck:close'. The prize is always the server's (lifecycle-api/api/luck.mjs); the browser
   only animates the index it is given. Physics ported unchanged from luck-game/luck-game-src.html (v1). */
(() => {
  'use strict';
  const modal = document.getElementById('jerseys-luck-modal');
  if (!modal || window.JRSLuckGame) return;
  const $ = (id) => document.getElementById('jl-' + id);
  const card = $('card');
  const NS = 'http://www.w3.org/2000/svg';
  const motionOff = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── copy (Daniel, 17.9; spec section 4) ── */
  const C = {
    drop: 'לחיצה לשחרור הכדור', dropBusy: 'הכדור בדרך', dropRetry: 'לחיצה לכדור נוסף', dropAgain: 'לנסות שוב',
    prizeLabel: 'הפרס שלכם:',
    prizes: ['5% הנחה', 'חולצה מתנה', 'עוד ניסיון', '10% הנחה', 'משלוח חינם עד הבית'],
    winCopyShirt: 'רוכשים שתי חולצות והשלישית במתנה. משאירים פרטים והקוד מופיע כאן.',
    winCopy: 'משאירים פרטים והקוד מופיע כאן.',
    retryKicker: 'כמעט.', retryCopy: 'הכדור חוזר אליך. עוד נפילה אחת.',
    claim: 'לקבל את הקוד', claimBusy: 'מכינים את הקוד',
    copyBtn: 'העתקת הקוד', copied: 'הועתק ✓', copyFail: 'אפשר לסמן ולהעתיק את הקוד.',
    okFine: (date) => 'בתוקף עד ' + date + ' · לשימוש אחד · ללא כפל מבצעים · בקופה עם אותו אימייל',
    previewNote: 'סביבת בדיקה · הפרסים נבחרים בשרת',
    previewForm: 'סביבת בדיקה. פרטי בדיקה בלבד, ללא שליחת הודעות.',
    nameError: 'איך קוראים לך? (לפחות שתי אותיות)', phoneError: 'בדקו שמספר הנייד מלא ותקין',
  };
  const PRIZE_KEYS = ['discount_5', 'bxgy_2plus1', 'retry', 'discount_10', 'free_shipping'];
  const receipt = (i) => (i === 1 ? C.prizes[1] + ' · <bdi dir="ltr">2+1</bdi>' : C.prizes[i]);
  const sentences = (s) => s.split(/(?<=\.)\s+/).map((x) => '<span class="s">' + x + '</span>').join(' ');

  /* ── session + API (unchanged from v1: same storage key and shape, the host snippet reads it) ── */
  const apiEndpoint = modal.getAttribute('data-luck-api') || '';
  const connected = Boolean(apiEndpoint);
  const storageKey = 'jerseys-luck-session-v1:' + apiEndpoint;
  let session;
  try { session = JSON.parse(localStorage.getItem(storageKey)); } catch (e) {}
  if (!session || !session.id) session = { id: (crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(16).slice(2)) };
  let coupon = session.coupon || null;
  let generation = 0;
  function remember() { try { localStorage.setItem(storageKey, JSON.stringify(session)); } catch (e) {} }
  const errors = {
    preview_identity: 'זו סביבת בדיקה. השתמשו בכתובת בדיקה שמסתיימת ב-example.invalid.',
    claimed: 'כבר נרשמה הטבה עם הפרטים האלה. נסו את הפרטים שאיתם התחלתם.',
    processing: 'הקוד בהכנה. חכו רגע ולחצו שוב.',
    rate: 'לקחנו הפסקה קצרה. נסו שוב מאוחר יותר.',
    expired: 'תוקף המשחק הזה הסתיים.',
    phone: 'בדקו שמספר הנייד מלא ותקין.',
    email: 'בדקו שכתובת האימייל נכונה.',
    name: 'בדקו את השם.',
    profile: 'בדקו את הפרטים, או דלגו ישר לקוד.',
  };
  async function request(action, fields) {
    const response = await fetch(apiEndpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({}, fields || {}, { id: session.id, token: session.token, attempt: session.attempt, action })),
      signal: AbortSignal.timeout(55000),
    });
    let data;
    try { data = await response.json(); } catch (e) { throw new Error('לא הצלחנו להתחבר כרגע. נסו שוב בעוד רגע.'); }
    if (!response.ok || !data.ok) throw new Error(errors[data.error] || 'לא הצלחנו להשלים כרגע. הפרס שלכם נשמר, נסו שוב.');
    return data;
  }
  if (connected) remember();
  function markPreview(data) {
    if (!data || !data.preview) return;
    $('note').textContent = C.previewNote;
    $('formfine').textContent = C.previewForm;
  }
  function chooseReward(value) { /* offline fallback only (no API on the modal) */
    const weights = [10, 62, 20, 7, 1];
    let total = 0;
    for (let i = 0; i < weights.length; i++) { total += weights[i]; if (value < total) return i; }
    return weights.length - 1;
  }

  /* ── pegs: 8 rows, 56 apart, rows every 59, on a 600x525 board (identical to v1) ── */
  const pegList = [], pegPhysics = [];
  for (let row = 0; row < 8; row++) {
    pegPhysics.push([]);
    for (let j = 0; j < row + 2; j++) {
      const cx = 300 + (j - (row + 1) / 2) * 56, cy = 54 + row * 59;
      const c = document.createElementNS(NS, 'circle');
      c.setAttribute('cx', cx); c.setAttribute('cy', cy); c.setAttribute('r', '5.4'); c.setAttribute('class', 'jl-peg');
      $('pegs').appendChild(c);
      pegList.push({ x: cx, y: cy, node: c });
      pegPhysics[row].push({ x: cx, y: cy });
    }
  }

  /* ── physics (v1, unchanged): gravity, real rebounds, seeded search for the server's slot ── */
  const BALL_R = 19, PEG_R = 5.8, HIT = BALL_R + PEG_R, FLOOR = 500, GRAVITY = 1800, STEP = 1 / 240, BOUNCE = 0.5, GRIP = 0.8;
  function seededRandom(seed) {
    let a = seed >>> 0;
    return () => { a = (a + 0x6d2b79f5) >>> 0; let t = Math.imul(a ^ (a >>> 15), 1 | a); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  }
  function simulateDrop(seed, slot, record) {
    const random = seededRandom(seed);
    let x = 300 + (random() - 0.5) * 14, y = 16, spin = 0;
    let vx = ((slot * 120 + 60 - 300) / 240) * 22 + (random() - 0.5) * 45, vy = 60;
    const path = record ? [] : null, rowsStruck = new Set();
    let calm = 0, bounces = 0, steps = 0, highest = 999;
    for (; steps < 240 * 6; steps++) {
      vy += GRAVITY * STEP; x += vx * STEP; y += vy * STEP; spin += vx * STEP * 2.4;
      if (y < highest) highest = y;
      if (x < BALL_R) { x = BALL_R; vx = Math.abs(vx) * BOUNCE; }
      if (x > 600 - BALL_R) { x = 600 - BALL_R; vx = -Math.abs(vx) * BOUNCE; }
      const near = Math.round((y - 54) / 59);
      for (let r = Math.max(0, near - 1); r <= Math.min(7, near + 1); r++) {
        for (const peg of pegPhysics[r]) {
          const dx = x - peg.x, dy = y - peg.y, distance = Math.sqrt(dx * dx + dy * dy);
          if (distance >= HIT || distance === 0) continue;
          const nx = dx / distance, ny = dy / distance;
          x = peg.x + nx * HIT; y = peg.y + ny * HIT;
          const normal = vx * nx + vy * ny;
          if (normal >= 0) continue;
          bounces++; rowsStruck.add(r);
          const tx = -ny, ty = nx, tangent = vx * tx + vy * ty, outNormal = -normal * BOUNCE, outTangent = tangent * GRIP + (random() - 0.5) * 60;
          vx = nx * outNormal + tx * outTangent; vy = ny * outNormal + ty * outTangent;
        }
      }
      if (y > FLOOR) { y = FLOOR; if (vy > 0) vy = -vy * 0.25; vx *= 0.35; }
      if (y >= FLOOR - 0.5 && Math.abs(vy) < 45 && Math.abs(vx) < 45) { vy = 0; vx *= 0.3; calm++; } else calm = 0;
      if (record && steps % 2 === 0) path.push(x, y, spin);
      if (calm > 8) break;
    }
    return { x, seconds: steps * STEP, bounces, rows: rowsStruck.size, highest, settled: calm > 8, path };
  }
  function throwBall(slot) {
    const centre = slot * 120 + 60;
    const good = (run) => run.settled && Math.floor(run.x / 120) === slot && Math.abs(run.x - centre) <= 40 && run.seconds >= 1.8 && run.seconds <= 3.6 && run.bounces >= 12 && run.bounces <= 70 && run.rows >= 5 && run.highest >= 0;
    let seed = (Math.random() * 1e9) | 0, bestSeed = seed, bestMiss = Infinity;
    for (let tries = 0; tries < 6000; tries++, seed++) {
      const run = simulateDrop(seed, slot, false);
      if (good(run)) return simulateDrop(seed, slot, true);
      const miss = Math.abs(run.x - centre) + (run.settled ? 0 : 400);
      if (miss < bestMiss) { bestMiss = miss; bestSeed = seed; }
    }
    const run = simulateDrop(bestSeed, slot, true), frames = run.path.length / 3;
    const shift = centre - run.path[run.path.length - 3], over = Math.min(frames - 1, 60);
    for (let n = 0; n < over; n++) run.path[(frames - over + n) * 3] += shift * ((n + 1) / over);
    return run;
  }

  /* ── state ── */
  let running = false, frame = 0, landedIndex = -1, anim = null;
  const setBall = (el, x, y, s) => el.setAttribute('transform', 'translate(' + x + ' ' + y + ') rotate(' + (s || 0) + ')');
  function clearLanding() {
    landedIndex = -1;
    card.classList.remove('is-landed', 'is-retry');
    [...$('slots').children].forEach((li) => li.classList.remove('won'));
    $('result').hidden = true;
  }
  function resetBoard() {
    generation++;
    cancelAnimationFrame(frame); anim = null; running = false;
    clearLanding();
    card.classList.remove('is-claimed', 'is-dropping', 'is-profile');
    document.querySelectorAll('#jerseys-luck-modal .jl-peg.hit').forEach((p) => p.classList.remove('hit'));
    setBall($('ball'), 300, 20, 0); ['g1', 'g2', 'g3'].forEach((id) => setBall($(id), 300, 20, 0));
    $('profile').hidden = true; $('success').hidden = true; $('form').hidden = false;
    $('drop').disabled = false; $('drop').textContent = C.drop; $('reveal').disabled = false;
    $('status').textContent = ''; $('form-error').textContent = ''; $('profile-error').textContent = '';
  }
  function renderLanding(index) {
    const k = $('kicker');
    if (index === 2) { k.textContent = C.retryKicker; k.classList.remove('is-label'); $('prize').textContent = C.prizes[2]; $('copy').innerHTML = sentences(C.retryCopy); return; }
    k.textContent = C.prizeLabel; k.classList.add('is-label'); $('prize').textContent = C.prizes[index];
    $('copy').innerHTML = sentences(index === 1 ? C.winCopyShirt : C.winCopy);
  }
  function land(index) {
    landedIndex = index;
    $('slots').children[index].classList.add('won');
    card.classList.remove('is-dropping');
    renderLanding(index);
    $('result').hidden = false;
    if (index === 2) {
      $('form').hidden = true;
      card.classList.add('is-landed');
      setTimeout(() => {
        if (landedIndex !== 2) return;
        card.classList.add('is-retry');
        $('drop').disabled = false; $('drop').textContent = C.dropRetry;
        try { $('drop').focus({ preventScroll: true }); } catch (e) {}
      }, motionOff ? 0 : 700);
      return;
    }
    $('form').hidden = false;
    card.classList.add('is-landed');
    setTimeout(() => {
      try { $('claim').scrollIntoView({ block: 'nearest', behavior: motionOff ? 'auto' : 'smooth' }); $('name').focus({ preventScroll: true }); } catch (e) {}
    }, motionOff ? 0 : 550);
  }
  function animate(index) {
    const run = throwBall(index), P = run.path, n = P.length / 3;
    const duration = motionOff ? 0 : (n - 1) * (1000 / 120);
    const hist = []; let start, lit = null;
    anim = { index };
    card.classList.add('is-dropping');
    function tick(now) {
      if (!anim) return;
      start = start === undefined ? now : start;
      const t = duration ? Math.min(1, (now - start) / duration) : 1, at = t * (n - 1), i = Math.min(n - 2, Math.floor(at)), u = at - i;
      const px = P[i * 3] + (P[i * 3 + 3] - P[i * 3]) * u, py = P[i * 3 + 1] + (P[i * 3 + 4] - P[i * 3 + 1]) * u, sp = P[i * 3 + 2] + (P[i * 3 + 5] - P[i * 3 + 2]) * u;
      let touching = null;
      for (const peg of pegList) { const dx = px - peg.x, dy = py - peg.y; if (dx * dx + dy * dy < (HIT + 2) * (HIT + 2)) { touching = peg; break; } }
      if (touching && touching !== lit) { const node = touching.node; node.classList.add('hit'); setTimeout(() => node.classList.remove('hit'), 260); }
      lit = touching;
      hist.push([px, py, sp]); if (hist.length > 7) hist.shift();
      setBall($('ball'), px, py, sp);
      const g = (k) => hist[Math.max(0, hist.length - 1 - k)];
      setBall($('g1'), ...g(2)); setBall($('g2'), ...g(4)); setBall($('g3'), ...g(6));
      if (t < 1) frame = requestAnimationFrame(tick);
      else { anim = null; running = false; land(index); }
    }
    frame = requestAnimationFrame(tick);
  }
  /* the modal closed mid-air: settle the ball now so the prize is on screen when it reopens */
  function settleNow() {
    if (!anim) return;
    const index = anim.index;
    cancelAnimationFrame(frame); anim = null; running = false;
    setBall($('ball'), index * 120 + 60, FLOOR, 0);
    land(index);
  }

  async function draw() {
    if (!connected) return chooseReward(Math.random() * 100);
    const data = await request('draw');
    markPreview(data);
    session.token = data.token; session.attempt = data.attempt; remember();
    return data.prize.index;
  }
  async function drop() {
    if (running) return;
    if (coupon) return restoreClaim();
    if (landedIndex >= 0 && landedIndex !== 2) return;
    if (landedIndex === 2) clearLanding();
    running = true; $('drop').disabled = true; $('drop').textContent = C.dropBusy; $('status').textContent = '';
    const gen = generation;
    let index;
    try { index = await draw(); } catch (error) {
      if (gen !== generation) return;
      running = false; $('drop').disabled = false; $('drop').textContent = C.dropAgain; $('status').textContent = error.message;
      return;
    }
    if (gen !== generation) return;
    animate(index);
  }
  /* "can't play? reveal": the prize without the animation, straight into the form. A retry draw is drawn again once. */
  async function reveal() {
    if (running || landedIndex >= 0) return;
    if (coupon) return restoreClaim();
    running = true; $('reveal').disabled = true; $('drop').disabled = true; $('status').textContent = '';
    const gen = generation;
    let index;
    try {
      index = await draw();
      if (index === 2) index = await draw();
    } catch (error) {
      if (gen !== generation) return;
      running = false; $('reveal').disabled = false; $('drop').disabled = false; $('status').textContent = error.message;
      return;
    }
    if (gen !== generation) return;
    running = false;
    setBall($('ball'), index * 120 + 60, FLOOR, 0);
    land(index);
  }

  /* ── forms ── */
  const PHONE = /^(?:05[0-9]{8}|(?:\+972|972)5[0-9]{8})$/;
  function profileStep() {
    card.classList.add('is-profile'); card.classList.remove('is-landed', 'is-retry');
    $('result').hidden = true; $('profile').hidden = false; $('receipt2').innerHTML = receipt(landedIndex);
    card.scrollTo({ top: 0, behavior: motionOff ? 'auto' : 'smooth' });
    setTimeout(() => { try { $('extra').querySelector('input:checked').focus({ preventScroll: true }); } catch (e) {} }, 100);
  }
  function claimed() {
    card.classList.add('is-claimed'); card.classList.remove('is-landed', 'is-retry', 'is-profile');
    $('result').hidden = true; $('profile').hidden = true; $('success').hidden = false;
    $('receipt').innerHTML = receipt(landedIndex);
    $('terms').hidden = landedIndex !== 1;
    if (connected && coupon) {
      $('codeval').textContent = coupon.code;
      $('okfine').textContent = C.okFine(new Date(coupon.expiresAt).toLocaleDateString('he-IL'));
      $('shop').href = coupon.shopUrl || '/collections/all';
    } else {
      $('codeval').textContent = ['DEMO-5', 'DEMO-2PLUS1', '', 'DEMO-10', 'DEMO-FREE-HOME'][landedIndex];
      $('shop').href = '/collections/all';
    }
    card.scrollTo({ top: 0, behavior: motionOff ? 'auto' : 'smooth' });
    setTimeout(() => { try { $('code').focus({ preventScroll: true }); } catch (e) {} }, 100);
  }
  /* returning visitor with an issued coupon: straight to the code */
  function restoreClaim() {
    resetBoard();
    landedIndex = Math.max(0, PRIZE_KEYS.indexOf(coupon.prize));
    claimed();
  }

  $('drop').addEventListener('click', drop);
  $('board').addEventListener('click', () => { if (landedIndex < 0) drop(); });
  $('reveal').addEventListener('click', reveal);
  $('name').addEventListener('input', () => $('name').setCustomValidity(''));
  $('phone').addEventListener('input', () => $('phone').setCustomValidity(''));
  $('birthday').max = new Date().toLocaleDateString('en-CA');
  $('form').addEventListener('submit', async (e) => {
    e.preventDefault();
    const name = $('name'), phone = $('phone'), email = $('email');
    if (name.value.trim().length < 2) { name.setCustomValidity(C.nameError); name.reportValidity(); return; }
    if (!PHONE.test(phone.value.replace(/[\s()-]/g, ''))) { phone.setCustomValidity(C.phoneError); phone.reportValidity(); return; }
    if (!email.checkValidity() || !email.value.includes('@')) { email.reportValidity(); return; }
    const button = $('claim');
    if (button.disabled) return;
    if (connected) {
      button.disabled = true; button.textContent = C.claimBusy; $('form-error').textContent = '';
      const gen = generation;
      try {
        coupon = await request('claim', { name: name.value, phone: phone.value, email: email.value, consent: $('consent').checked });
        session.coupon = { code: coupon.code, prize: coupon.prize, expiresAt: coupon.expiresAt, shopUrl: coupon.shopUrl };
        remember();
        if (gen !== generation) return;
      } catch (error) {
        $('form-error').textContent = error.message;
        return;
      } finally {
        button.disabled = false; button.textContent = C.claim;
      }
    }
    profileStep();
  });
  const TEAM_CODES = ['', 'real-madrid', 'barcelona', 'manchester-united', 'liverpool', 'manchester-city', 'arsenal', 'bayern-munich', 'chelsea', 'borussia-dortmund', 'tottenham', 'ac-milan', 'inter-milan', 'psg', 'atletico-madrid', 'other'];
  $('extra').addEventListener('submit', async (e) => {
    e.preventDefault();
    const button = $('extrago');
    if (button.disabled) return;
    if (connected) {
      button.disabled = true; $('profile-error').textContent = '';
      const gender = (document.querySelector('#jl-extra input[name="jl-addressing"]:checked') || {}).value;
      try {
        await request('profile', { gender, birthday: $('birthday').value, team: TEAM_CODES[$('team').selectedIndex], teamOther: $('otherteam').value });
      } catch (error) {
        $('profile-error').textContent = error.message;
        return;
      } finally { button.disabled = false; }
    }
    claimed();
  });
  $('skip').addEventListener('click', claimed);
  $('back').addEventListener('click', () => {
    card.classList.remove('is-profile'); card.classList.add('is-landed');
    $('profile').hidden = true; $('result').hidden = false;
    try { $('name').focus({ preventScroll: true }); } catch (e) {}
  });
  $('team').addEventListener('change', () => { $('otherwrap').hidden = $('team').value !== 'other'; });
  $('code').addEventListener('click', async () => {
    const code = $('codeval').textContent;
    try { await navigator.clipboard.writeText(code); $('copylabel').textContent = C.copied; $('code').classList.add('copied'); }
    catch (e) { $('copylabel').textContent = C.copyFail; }
    setTimeout(() => { $('code').classList.remove('copied'); $('copylabel').textContent = C.copyBtn; }, 1600);
  });

  /* ── host contract ── */
  function show() {
    if (coupon) { restoreClaim(); return; }
    const target = card.classList.contains('is-claimed') ? $('code') : card.classList.contains('is-profile') ? $('extra').querySelector('input:checked') : landedIndex >= 0 && landedIndex !== 2 ? $('name') : $('drop');
    try { target.focus({ preventScroll: true }); } catch (e) {}
  }
  function hide() { settleNow(); }
  document.addEventListener('jrs:luck:open', show);
  document.addEventListener('jrs:luck:close', hide);
  /* focus trap: Tab cycles inside the card */
  modal.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const f = [...card.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')].filter((el) => el.getClientRects().length && !el.closest('[hidden]'));
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  window.JRSLuckGame = { show, hide };
  resetBoard();
  if (coupon) restoreClaim();
  if (!modal.hidden) show();
})();
